import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _3c78fa08 = () => interopDefault(import('..\\pages\\blocked.vue' /* webpackChunkName: "pages/blocked" */))
const _931f486e = () => interopDefault(import('..\\pages\\dev-help\\index.vue' /* webpackChunkName: "pages/dev-help/index" */))
const _3c1a47f9 = () => interopDefault(import('..\\pages\\login.vue' /* webpackChunkName: "pages/login" */))
const _d78080ac = () => interopDefault(import('..\\pages\\logout.vue' /* webpackChunkName: "pages/logout" */))
const _407ba5be = () => interopDefault(import('..\\pages\\backoffice\\authorization-error\\index.vue' /* webpackChunkName: "pages/backoffice/authorization-error/index" */))
const _122adc1c = () => interopDefault(import('..\\pages\\backoffice\\catalog\\index.vue' /* webpackChunkName: "pages/backoffice/catalog/index" */))
const _89982242 = () => interopDefault(import('..\\pages\\backoffice\\configuration\\index.vue' /* webpackChunkName: "pages/backoffice/configuration/index" */))
const _420e2690 = () => interopDefault(import('..\\..\\Frontends\\Vlora\\pages\\backoffice\\custom\\dashboard\\index.vue' /* webpackChunkName: "" */))
const _3c3a6e83 = () => interopDefault(import('..\\pages\\backoffice\\media-library\\index.vue' /* webpackChunkName: "pages/backoffice/media-library/index" */))
const _4f2dced2 = () => interopDefault(import('..\\pages\\backoffice\\my-profile\\index.vue' /* webpackChunkName: "pages/backoffice/my-profile/index" */))
const _333fc6ba = () => interopDefault(import('..\\pages\\backoffice\\product-catalog\\index.vue' /* webpackChunkName: "pages/backoffice/product-catalog/index" */))
const _0bc11ad8 = () => interopDefault(import('..\\pages\\backoffice\\seo\\index.vue' /* webpackChunkName: "pages/backoffice/seo/index" */))
const _990b27e0 = () => interopDefault(import('..\\pages\\backoffice\\shopping-cart\\index.vue' /* webpackChunkName: "pages/backoffice/shopping-cart/index" */))
const _4f56427a = () => interopDefault(import('..\\pages\\backoffice\\wishlist\\index.vue' /* webpackChunkName: "pages/backoffice/wishlist/index" */))
const _31720f16 = () => interopDefault(import('..\\pages\\backoffice\\cms\\components\\index.vue' /* webpackChunkName: "pages/backoffice/cms/components/index" */))
const _23d42512 = () => interopDefault(import('..\\pages\\backoffice\\cms\\contents\\index.vue' /* webpackChunkName: "pages/backoffice/cms/contents/index" */))
const _42739f3e = () => interopDefault(import('..\\pages\\backoffice\\financial\\customer-credits\\index.vue' /* webpackChunkName: "pages/backoffice/financial/customer-credits/index" */))
const _381bf374 = () => interopDefault(import('..\\pages\\backoffice\\financial\\invoices\\index.vue' /* webpackChunkName: "pages/backoffice/financial/invoices/index" */))
const _045910c2 = () => interopDefault(import('..\\pages\\backoffice\\financial\\payments\\index.vue' /* webpackChunkName: "pages/backoffice/financial/payments/index" */))
const _0af879f9 = () => interopDefault(import('..\\pages\\backoffice\\order-creation\\estimate\\index.vue' /* webpackChunkName: "pages/backoffice/order-creation/estimate/index" */))
const _40e1d46d = () => interopDefault(import('..\\pages\\backoffice\\status-tracking\\consignments\\index.vue' /* webpackChunkName: "pages/backoffice/status-tracking/consignments/index" */))
const _56f40345 = () => interopDefault(import('..\\..\\Frontends\\Vlora\\pages\\backoffice\\custom\\status-tracking\\job-orders\\index.vue' /* webpackChunkName: "" */))
const _50595783 = () => interopDefault(import('..\\..\\Frontends\\Vlora\\pages\\backoffice\\custom\\status-tracking\\quotes\\index.vue' /* webpackChunkName: "" */))
const _55e068c6 = () => interopDefault(import('..\\pages\\backoffice\\status-tracking\\sales-orders\\index.vue' /* webpackChunkName: "pages/backoffice/status-tracking/sales-orders/index" */))
const _146d1929 = () => interopDefault(import('..\\pages\\backoffice\\order-creation\\custom-order\\item-type\\_id\\index.vue' /* webpackChunkName: "pages/backoffice/order-creation/custom-order/item-type/_id/index" */))
const _11216125 = () => interopDefault(import('..\\pages\\backoffice\\cms\\components\\_componentId.vue' /* webpackChunkName: "pages/backoffice/cms/components/_componentId" */))
const _4c821465 = () => interopDefault(import('..\\pages\\backoffice\\cms\\contents\\_contentId.vue' /* webpackChunkName: "pages/backoffice/cms/contents/_contentId" */))
const _625ea4d2 = () => interopDefault(import('..\\pages\\backoffice\\order-creation\\custom-order\\_id.vue' /* webpackChunkName: "pages/backoffice/order-creation/custom-order/_id" */))
const _5b1d1651 = () => interopDefault(import('..\\pages\\backoffice\\product-catalog\\_productCategoryId.vue' /* webpackChunkName: "pages/backoffice/product-catalog/_productCategoryId" */))
const _6d7c4186 = () => interopDefault(import('..\\..\\Frontends\\Vlora\\pages\\backoffice\\custom\\product\\_id\\index.vue' /* webpackChunkName: "" */))
const _143721c7 = () => interopDefault(import('..\\..\\Frontends\\Vlora\\pages\\backoffice\\custom\\catalog\\_id\\products' /* webpackChunkName: "" */))
const _6015ba7a = () => interopDefault(import('..\\pages\\backoffice\\catalog\\_id\\products\\_masterItemTypeId\\variants\\index.vue' /* webpackChunkName: "pages/backoffice/catalog/_id/products/_masterItemTypeId/variants/index" */))
const _1c4f95bb = () => interopDefault(import('..\\..\\Frontends\\Vlora\\frontend\\components\\layout\\price-quote-version-detail.vue' /* webpackChunkName: "" */))
const _536a2c22 = () => interopDefault(import('..\\pages\\_.vue' /* webpackChunkName: "pages/_" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/blocked",
    component: _3c78fa08,
    name: "blocked___en"
  }, {
    path: "/dev-help",
    component: _931f486e,
    name: "dev-help___en"
  }, {
    path: "/login",
    component: _3c1a47f9,
    name: "login___en"
  }, {
    path: "/logout",
    component: _d78080ac,
    name: "logout___en"
  }, {
    path: "/backoffice/authorization-error",
    component: _407ba5be,
    name: "backoffice-authorization-error___en"
  }, {
    path: "/backoffice/catalog",
    component: _122adc1c,
    name: "backoffice-catalog___en"
  }, {
    path: "/backoffice/configuration",
    component: _89982242,
    name: "backoffice-configuration___en"
  }, {
    path: "/backoffice/dashboard",
    component: _420e2690,
    name: "dashboard___en"
  }, {
    path: "/backoffice/media-library",
    component: _3c3a6e83,
    name: "backoffice-media-library___en"
  }, {
    path: "/backoffice/my-profile",
    component: _4f2dced2,
    name: "backoffice-my-profile___en"
  }, {
    path: "/backoffice/product-catalog",
    component: _333fc6ba,
    name: "backoffice-product-catalog___en"
  }, {
    path: "/backoffice/seo",
    component: _0bc11ad8,
    name: "backoffice-seo___en"
  }, {
    path: "/backoffice/shopping-cart",
    component: _990b27e0,
    name: "backoffice-shopping-cart___en"
  }, {
    path: "/backoffice/wishlist",
    component: _4f56427a,
    name: "backoffice-wishlist___en"
  }, {
    path: "/fr/blocked",
    component: _3c78fa08,
    name: "blocked___fr"
  }, {
    path: "/fr/dev-help",
    component: _931f486e,
    name: "dev-help___fr"
  }, {
    path: "/fr/login",
    component: _3c1a47f9,
    name: "login___fr"
  }, {
    path: "/fr/logout",
    component: _d78080ac,
    name: "logout___fr"
  }, {
    path: "/backoffice/cms/components",
    component: _31720f16,
    name: "backoffice-cms-components___en"
  }, {
    path: "/backoffice/cms/contents",
    component: _23d42512,
    name: "backoffice-cms-contents___en"
  }, {
    path: "/backoffice/financial/customer-credits",
    component: _42739f3e,
    name: "backoffice-financial-customer-credits___en"
  }, {
    path: "/backoffice/financial/invoices",
    component: _381bf374,
    name: "backoffice-financial-invoices___en"
  }, {
    path: "/backoffice/financial/payments",
    component: _045910c2,
    name: "backoffice-financial-payments___en"
  }, {
    path: "/backoffice/order-creation/estimate",
    component: _0af879f9,
    name: "backoffice-order-creation-estimate___en"
  }, {
    path: "/backoffice/status-tracking/consignments",
    component: _40e1d46d,
    name: "backoffice-status-tracking-consignments___en"
  }, {
    path: "/backoffice/status-tracking/job-orders",
    component: _56f40345,
    name: "job-orders___en"
  }, {
    path: "/backoffice/status-tracking/quotes",
    component: _50595783,
    name: "quotes___en"
  }, {
    path: "/backoffice/status-tracking/sales-orders",
    component: _55e068c6,
    name: "backoffice-status-tracking-sales-orders___en"
  }, {
    path: "/fr/backoffice/authorization-error",
    component: _407ba5be,
    name: "backoffice-authorization-error___fr"
  }, {
    path: "/fr/backoffice/catalog",
    component: _122adc1c,
    name: "backoffice-catalog___fr"
  }, {
    path: "/fr/backoffice/configuration",
    component: _89982242,
    name: "backoffice-configuration___fr"
  }, {
    path: "/fr/backoffice/dashboard",
    component: _420e2690,
    name: "dashboard___fr"
  }, {
    path: "/fr/backoffice/media-library",
    component: _3c3a6e83,
    name: "backoffice-media-library___fr"
  }, {
    path: "/fr/backoffice/my-profile",
    component: _4f2dced2,
    name: "backoffice-my-profile___fr"
  }, {
    path: "/fr/backoffice/product-catalog",
    component: _333fc6ba,
    name: "backoffice-product-catalog___fr"
  }, {
    path: "/fr/backoffice/seo",
    component: _0bc11ad8,
    name: "backoffice-seo___fr"
  }, {
    path: "/fr/backoffice/shopping-cart",
    component: _990b27e0,
    name: "backoffice-shopping-cart___fr"
  }, {
    path: "/fr/backoffice/wishlist",
    component: _4f56427a,
    name: "backoffice-wishlist___fr"
  }, {
    path: "/fr/backoffice/cms/components",
    component: _31720f16,
    name: "backoffice-cms-components___fr"
  }, {
    path: "/fr/backoffice/cms/contents",
    component: _23d42512,
    name: "backoffice-cms-contents___fr"
  }, {
    path: "/fr/backoffice/financial/customer-credits",
    component: _42739f3e,
    name: "backoffice-financial-customer-credits___fr"
  }, {
    path: "/fr/backoffice/financial/invoices",
    component: _381bf374,
    name: "backoffice-financial-invoices___fr"
  }, {
    path: "/fr/backoffice/financial/payments",
    component: _045910c2,
    name: "backoffice-financial-payments___fr"
  }, {
    path: "/fr/backoffice/order-creation/estimate",
    component: _0af879f9,
    name: "backoffice-order-creation-estimate___fr"
  }, {
    path: "/fr/backoffice/status-tracking/consignments",
    component: _40e1d46d,
    name: "backoffice-status-tracking-consignments___fr"
  }, {
    path: "/fr/backoffice/status-tracking/job-orders",
    component: _56f40345,
    name: "job-orders___fr"
  }, {
    path: "/fr/backoffice/status-tracking/quotes",
    component: _50595783,
    name: "quotes___fr"
  }, {
    path: "/fr/backoffice/status-tracking/sales-orders",
    component: _55e068c6,
    name: "backoffice-status-tracking-sales-orders___fr"
  }, {
    path: "/fr/backoffice/order-creation/custom-order/item-type/:id",
    component: _146d1929,
    name: "backoffice-order-creation-custom-order-item-type-id___fr"
  }, {
    path: "/backoffice/order-creation/custom-order/item-type/:id",
    component: _146d1929,
    name: "backoffice-order-creation-custom-order-item-type-id___en"
  }, {
    path: "/fr/backoffice/cms/components/:componentId",
    component: _11216125,
    name: "backoffice-cms-components-componentId___fr"
  }, {
    path: "/fr/backoffice/cms/contents/:contentId",
    component: _4c821465,
    name: "backoffice-cms-contents-contentId___fr"
  }, {
    path: "/fr/backoffice/order-creation/custom-order/:id?",
    component: _625ea4d2,
    name: "backoffice-order-creation-custom-order-id___fr"
  }, {
    path: "/backoffice/cms/components/:componentId",
    component: _11216125,
    name: "backoffice-cms-components-componentId___en"
  }, {
    path: "/backoffice/cms/contents/:contentId",
    component: _4c821465,
    name: "backoffice-cms-contents-contentId___en"
  }, {
    path: "/backoffice/order-creation/custom-order/:id?",
    component: _625ea4d2,
    name: "backoffice-order-creation-custom-order-id___en"
  }, {
    path: "/fr/backoffice/product-catalog/:productCategoryId?",
    component: _5b1d1651,
    name: "backoffice-product-catalog-productCategoryId___fr"
  }, {
    path: "/fr/backoffice/product/:id",
    component: _6d7c4186,
    name: "product___fr"
  }, {
    path: "/fr/backoffice/catalog/:id/products",
    component: _143721c7,
    name: "product___fr"
  }, {
    path: "/fr/backoffice/catalog/:id/products/:masterItemTypeId/variants",
    component: _6015ba7a,
    name: "backoffice-catalog-id-products-masterItemTypeId-variants___fr"
  }, {
    path: "/backoffice/product-catalog/:productCategoryId?",
    component: _5b1d1651,
    name: "backoffice-product-catalog-productCategoryId___en"
  }, {
    path: "/backoffice/product/:id",
    component: _6d7c4186,
    name: "product___en"
  }, {
    path: "/backoffice/catalog/:id/products",
    component: _143721c7,
    name: "product___en"
  }, {
    path: "/backoffice/catalog/:id/products/:masterItemTypeId/variants",
    component: _6015ba7a,
    name: "backoffice-catalog-id-products-masterItemTypeId-variants___en"
  }, {
    path: "/fr/des/:versionNumber/:versionItemHash",
    component: _1c4f95bb,
    name: "price-quote-version-detail___fr"
  }, {
    path: "/des/:versionNumber/:versionItemHash",
    component: _1c4f95bb,
    name: "price-quote-version-detail___en"
  }, {
    path: "/fr/*",
    component: _536a2c22,
    name: "all___fr"
  }, {
    path: "/*",
    component: _536a2c22,
    name: "all___en"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config.app && config.app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
